import React from 'react';
import {
  Container,
  Row,
  Col,
  CardBody,
  Button,
  Media,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
} from 'reactstrap';
import SimpleBar from 'simplebar-react';
import dayjs from 'dayjs';
import useGet from '../../helpers/hooks/useGet';
import ReactAudioPlayer from 'react-audio-player';
const getChat = (message) => {
  switch (message.type) {
    case 'TEXT':
      return <p className='mb-0'>{message.content}</p>;
      break;
    case 'IMAGE':
      return (
        <img
          style={{ height: '20rem', width: '20rem' }}
          className='mb-0 img-fluid avatar-xl rounded'
          src={message.content}
        />
      );
      break;
    case 'VIDEO':
      return <video controls src={message.content} />;
      break;
    case 'AUDIO':
      return (
        <ReactAudioPlayer
          src={message.content}
          autoPlay={false}
          controls
          preload='auto'
        />
      );
      break;
    default:
      return <p className='mb-0'>CONFIRMATION</p>;
      break;
  }
};
function AdvisorySessionChats(props) {
  const [session, sessionError, sessionLoading] = useGet(
    `/advisory-sessions/${props.match.params.id}?filter=${encodeURIComponent(
      JSON.stringify({
        include: [
          { relation: 'farmer' },
          { relation: 'expertise' },
          { relation: 'advisory' },
        ],
      })
    )}`,
    true
  );
  const [chats, chatError, chatLoading] = useGet(
    `/advisory-sessions/${props.match.params.id}/advisory-chats`,
    true
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='d-lg-flex mb-4'>
            <div className='w-100 user-chat mt-4 mt-sm-0'>
              <div className='p-3 px-lg-4 user-chat-border'>
                <Row>
                  <Col md={4} xs={6}>
                    <h5 className='font-size-15 mb-1 text-truncate py-2'>
                      Expertise Required: {session?.expertise.name}
                    </h5>
                  </Col>
                  {/* <Col md={8} xs={6}>
                      <ul className='list-inline user-chat-nav text-right mb-0'>
                        <li className='list-inline-item d-inline-block d-sm-none'>
                          <Dropdown
                            isOpen={this.state.settings}
                            toggle={() =>
                              this.setState({ settings: !this.state.settings })
                            }
                          >
                            <DropdownToggle
                              className='btn nav-btn dropdown-toggle'
                              type='button'
                            >
                              <i className='mdi mdi-magnify'></i>
                            </DropdownToggle>
                            <DropdownMenu right className='dropdown-menu-md'>
                              <Form className='p-2'>
                                <div className='search-box'>
                                  <div className='position-relative'>
                                    <Input
                                      type='text'
                                      className='form-control rounded'
                                      placeholder='Search...'
                                    />
                                    <i className='mdi mdi-magnify search-icon'></i>
                                  </div>
                                </div>
                              </Form>
                            </DropdownMenu>
                          </Dropdown>
                        </li>
                        <li className='d-none d-sm-inline-block'>
                          <div className='search-box mr-2'>
                            <div className='position-relative'>
                              <Input
                                type='text'
                                className='form-control'
                                placeholder='Search...'
                              />
                              <i className='mdi mdi-magnify search-icon'></i>
                            </div>
                          </div>
                        </li>
                        <li className='list-inline-item m-0 d-none d-sm-inline-block'>
                          <Dropdown
                            isOpen={this.state.settings2}
                            toggle={() =>
                              this.setState({
                                settings2: !this.state.settings2,
                              })
                            }
                          >
                            <DropdownToggle className='btn nav-btn' tag='i'>
                              <i className='mdi mdi-cog'></i>
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem href='#'>View Profile</DropdownItem>
                              <DropdownItem href='#'>Clear chat</DropdownItem>
                              <DropdownItem href='#'>Muted</DropdownItem>
                              <DropdownItem href='#'>Delete</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </li>

                        <li className='list-inline-item'>
                          <Dropdown
                            isOpen={this.state.other2}
                            toggle={() =>
                              this.setState({ other2: !this.state.other2 })
                            }
                          >
                            <DropdownToggle className='btn nav-btn ' tag='i'>
                              <i className='mdi mdi-dots-horizontal'></i>
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem href='#'>Action</DropdownItem>
                              <DropdownItem href='#'>
                                Another action
                              </DropdownItem>
                              <DropdownItem href='#'>
                                Something else
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </li>
                      </ul>
                    </Col> */}
                </Row>
              </div>

              <div className='px-lg-2'>
                <div className='chat-conversation p-3 chat-conversation-height'>
                  <ul className='list-unstyled mb-0 pr-3'>
                    <SimpleBar style={{ maxHeight: '450px' }}>
                      {chats?.map((message, key) => (
                        <li
                          key={key}
                          className={
                            message?.fromUser === 'ADVISORY' ? 'right' : ''
                          }
                          style={{ paddingRight: '20px' }}
                        >
                          <div className='conversation-list'>
                            {message?.fromUser === 'FARMER' && (
                              <div className='chat-avatar pt-3'>
                                <img
                                  src={
                                    message?.fromUser === 'ADVISORY'
                                      ? session?.advisory.image
                                      : session?.farmer.profilePicture
                                  }
                                  alt=''
                                />
                              </div>
                            )}

                            <div className='ctext-wrap'>
                              <div className='conversation-name pt-3'>
                                {message?.fromUser === 'ADVISORY'
                                  ? session?.advisory.name
                                  : session?.farmer.name}
                              </div>
                              <div className='ctext-wrap-content'>
                                {getChat(message)}
                              </div>
                              <p className='chat-time mb-0'>
                                <i className='mdi mdi-clock-outline align-middle mr-1'></i>{' '}
                                {dayjs(message.createdAt).format(
                                  'DD/MM/YYYY HH:mm:ss'
                                )}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </SimpleBar>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default AdvisorySessionChats;
